import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";
import { CertificationEconomicAnalysisDto } from "@/core/features/certification-economic-analyses/certification-economic-analysis.dto";
import { DossierDto } from "@/core/features/dossiers/dtos/dossier.dto";
import { FileDto } from "@/core/features/file/file.dto";
import { CertificationHasInvoiceDto } from "@/core/features/certifications-have-invoices/certification-has-invoice.dto";
import { ProjectHasCertificationDto } from "@/core/features/projects-have-certifications/project-has-certification.dto";
import { WorksheetDto } from "@/core/features/worksheets/worksheet.dto";
import { parseApiDate } from "@/utils/dates/dateFormats";
import { toEuros } from "@/utils/numberUtils";
import { CertificationStatusEnum } from "@altertec_gparn/lib";
import { Transform, Type } from "class-transformer";

export class CertificationDto extends BaseEntityDto {
  code: string;

  @Type(() => DossierDto)
  dossier: DossierDto;
  dossierId: string;

  @Transform(({ value }) => (value ? parseApiDate(value) : null))
  startDate?: Date;

  @Transform(({ value }) => (value ? parseApiDate(value) : null))
  endDate?: Date;

  @Transform(({ value }) => (value ? parseApiDate(value) : null))
  registrationDate?: Date;

  @Transform(({ value }) => (value ? parseApiDate(value) : null))
  certificationSentDate?: Date;

  @Transform(({ value }) => (value ? parseApiDate(value) : null))
  otReportSentDate?: Date;

  @Transform(({ value }) => (value ? parseApiDate(value) : null))
  clientApprovalDate?: Date;

  @Transform(({ value }) => (value ? parseApiDate(value) : null))
  movedToBillingDate?: Date;

  contactPerson?: string;
  otQuantity?: number;

  @Transform(({ value }) => toEuros(value, false))
  totalAmount: number;

  @Transform(({ value }) => (value == null ? null : toEuros(value, true)))
  remainingToInvoiceAmount?: number | null;

  @Transform(({ value }) => (value == null ? null : toEuros(value, true)))
  invoicedAmount?: number | null;

  @Transform(({ value }) => (value == null ? null : toEuros(value, true)))
  deliverableTotalAmount?: number | null;

  status: CertificationStatusEnum;

  @Type(() => ProjectHasCertificationDto)
  certificationHasProjects: ProjectHasCertificationDto[];

  @Type(() => WorksheetDto)
  worksheets: WorksheetDto[];

  @Type(() => WorksheetDto)
  expenses: WorksheetDto[];

  @Type(() => CertificationHasInvoiceDto)
  certificationHasInvoices: CertificationHasInvoiceDto[];

  @Type(() => FileDto)
  files: FileDto[];

  @Type(() => CertificationEconomicAnalysisDto)
  economicAnalysis: CertificationEconomicAnalysisDto;
  economicAnalysisId: string;

  toString(): string {
    return this.code;
  }

  hasLinkedInvoices(): boolean {
    return !!this.certificationHasInvoices?.length;
  }

  canEditInvoices(): boolean {
    return (
      this.status == CertificationStatusEnum.INVOICE_DELIVERY ||
      this.status == CertificationStatusEnum.PARTIALLY_INVOICED ||
      this.status == CertificationStatusEnum.BILLED
    );
  }

  isEditable(): boolean {
    return this.status === CertificationStatusEnum.DRAFT;
  }

  canSetRegistrationDate(): boolean {
    return !this.registrationDate;
  }
}
